import {createContext, React} from 'react';


export const Context = createContext({})